import React from 'react';

import style from './index.style';
import { Link } from 'components/utils/Link';

export default function VariantSelector({ variants }) {
  return (
    <div className="s-container mb-xl">
      {variants?.map((variant) => {
        const splittedBicolors = variant?.attributes?.bicolors?.split(',');
        const firstBackgroundColor = splittedBicolors?.[0];
        const secondBackgroundColor =
          splittedBicolors?.[1] || variant?.attributes?.color;

        return (
          <div key={variant?.refId}>
            <Link
              href={
                variant?.availability > 0 &&
                `/product/${variant?.attributes?.brand}-${variant?.attributes?.subcategory}-${variant?.code}-${variant?.refId}`
              }
            >
              <div
                style={{
                  background: splittedBicolors
                    ? `linear-gradient(135deg, ${firstBackgroundColor} 50%, ${secondBackgroundColor} 50%)`
                    : variant?.attributes?.color,
                }}
                className={`size mt-xl ${
                  variant?.availability === 0 && 'size-disabled'
                }`}
              ></div>
            </Link>
          </div>
        );
      })}
      <style jsx>{style}</style>
    </div>
  );
}
